 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		196: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"chunk-web-stories-template-102","1":"chunk-web-stories-template-110","2":"chunk-web-stories-template-118","3":"chunk-web-stories-template-126","4":"chunk-web-stories-template-134","5":"chunk-web-stories-template-14","6":"chunk-web-stories-template-142","7":"chunk-web-stories-template-150","8":"chunk-web-stories-template-158","9":"chunk-web-stories-template-166","10":"chunk-web-stories-template-174","11":"chunk-web-stories-template-182","12":"chunk-web-stories-template-190","13":"chunk-web-stories-template-198","14":"chunk-web-stories-template-206","15":"chunk-web-stories-template-214","16":"chunk-web-stories-template-22","17":"chunk-web-stories-template-222","18":"chunk-web-stories-template-230","19":"chunk-web-stories-template-238","20":"chunk-web-stories-template-246","21":"chunk-web-stories-template-254","22":"chunk-web-stories-template-262","23":"chunk-web-stories-template-270","24":"chunk-web-stories-template-278","25":"chunk-web-stories-template-286","26":"chunk-web-stories-template-294","27":"chunk-web-stories-template-30","28":"chunk-web-stories-template-302","29":"chunk-web-stories-template-310","30":"chunk-web-stories-template-318","31":"chunk-web-stories-template-326","32":"chunk-web-stories-template-334","33":"chunk-web-stories-template-342","34":"chunk-web-stories-template-350","35":"chunk-web-stories-template-358","36":"chunk-web-stories-template-366","37":"chunk-web-stories-template-374","38":"chunk-web-stories-template-38","39":"chunk-web-stories-template-382","40":"chunk-web-stories-template-390","41":"chunk-web-stories-template-398","42":"chunk-web-stories-template-406","43":"chunk-web-stories-template-414","44":"chunk-web-stories-template-422","45":"chunk-web-stories-template-430","46":"chunk-web-stories-template-438","47":"chunk-web-stories-template-446","48":"chunk-web-stories-template-454","49":"chunk-web-stories-template-46","50":"chunk-web-stories-template-462","51":"chunk-web-stories-template-470","52":"chunk-web-stories-template-478","53":"chunk-web-stories-template-486","54":"chunk-web-stories-template-54","55":"chunk-web-stories-template-6","56":"chunk-web-stories-template-62","57":"chunk-web-stories-template-70","58":"chunk-web-stories-template-78","59":"chunk-web-stories-template-86","60":"chunk-web-stories-template-94","61":"chunk-web-stories-template-0","62":"chunk-web-stories-template-104","63":"chunk-web-stories-template-112","64":"chunk-web-stories-template-120","65":"chunk-web-stories-template-128","66":"chunk-web-stories-template-136","67":"chunk-web-stories-template-144","68":"chunk-web-stories-template-152","69":"chunk-web-stories-template-16","70":"chunk-web-stories-template-160","71":"chunk-web-stories-template-168","72":"chunk-web-stories-template-176","73":"chunk-web-stories-template-184","74":"chunk-web-stories-template-192","75":"chunk-web-stories-template-200","76":"chunk-web-stories-template-208","77":"chunk-web-stories-template-216","78":"chunk-web-stories-template-224","79":"chunk-web-stories-template-232","80":"chunk-web-stories-template-24","81":"chunk-web-stories-template-240","82":"chunk-web-stories-template-248","83":"chunk-web-stories-template-256","84":"chunk-web-stories-template-264","85":"chunk-web-stories-template-272","86":"chunk-web-stories-template-280","87":"chunk-web-stories-template-288","88":"chunk-web-stories-template-296","89":"chunk-web-stories-template-304","90":"chunk-web-stories-template-312","91":"chunk-web-stories-template-32","92":"chunk-web-stories-template-320","93":"chunk-web-stories-template-328","94":"chunk-web-stories-template-336","95":"chunk-web-stories-template-344","96":"chunk-web-stories-template-352","97":"chunk-web-stories-template-360","98":"chunk-web-stories-template-368","99":"chunk-web-stories-template-376","100":"chunk-web-stories-template-384","101":"chunk-web-stories-template-392","102":"chunk-web-stories-template-40","103":"chunk-web-stories-template-400","104":"chunk-web-stories-template-408","105":"chunk-web-stories-template-416","106":"chunk-web-stories-template-424","107":"chunk-web-stories-template-432","108":"chunk-web-stories-template-440","109":"chunk-web-stories-template-448","110":"chunk-web-stories-template-456","111":"chunk-web-stories-template-464","112":"chunk-web-stories-template-472","113":"chunk-web-stories-template-48","114":"chunk-web-stories-template-480","115":"chunk-web-stories-template-56","116":"chunk-web-stories-template-64","117":"chunk-web-stories-template-72","118":"chunk-web-stories-template-8","119":"chunk-web-stories-template-80","120":"chunk-web-stories-template-88","121":"chunk-web-stories-template-96","122":"chunk-web-stories-template-100","123":"chunk-web-stories-template-108","124":"chunk-web-stories-template-116","125":"chunk-web-stories-template-12","126":"chunk-web-stories-template-124","127":"chunk-web-stories-template-132","128":"chunk-web-stories-template-140","129":"chunk-web-stories-template-148","130":"chunk-web-stories-template-156","131":"chunk-web-stories-template-164","132":"chunk-web-stories-template-172","133":"chunk-web-stories-template-180","134":"chunk-web-stories-template-188","135":"chunk-web-stories-template-196","136":"chunk-web-stories-template-20","137":"chunk-web-stories-template-204","138":"chunk-web-stories-template-212","139":"chunk-web-stories-template-220","140":"chunk-web-stories-template-228","141":"chunk-web-stories-template-236","142":"chunk-web-stories-template-244","143":"chunk-web-stories-template-252","144":"chunk-web-stories-template-260","145":"chunk-web-stories-template-268","146":"chunk-web-stories-template-276","147":"chunk-web-stories-template-28","148":"chunk-web-stories-template-284","149":"chunk-web-stories-template-292","150":"chunk-web-stories-template-300","151":"chunk-web-stories-template-308","152":"chunk-web-stories-template-316","153":"chunk-web-stories-template-324","154":"chunk-web-stories-template-332","155":"chunk-web-stories-template-340","156":"chunk-web-stories-template-348","157":"chunk-web-stories-template-356","158":"chunk-web-stories-template-36","159":"chunk-web-stories-template-364","160":"chunk-web-stories-template-372","161":"chunk-web-stories-template-380","162":"chunk-web-stories-template-388","163":"chunk-web-stories-template-396","164":"chunk-web-stories-template-4","165":"chunk-web-stories-template-404","166":"chunk-web-stories-template-412","167":"chunk-web-stories-template-420","168":"chunk-web-stories-template-428","169":"chunk-web-stories-template-436","170":"chunk-web-stories-template-44","171":"chunk-web-stories-template-444","172":"chunk-web-stories-template-452","173":"chunk-web-stories-template-460","174":"chunk-web-stories-template-468","175":"chunk-web-stories-template-476","176":"chunk-web-stories-template-484","177":"chunk-web-stories-template-52","178":"chunk-web-stories-template-60","179":"chunk-web-stories-template-68","180":"chunk-web-stories-template-76","181":"chunk-web-stories-template-84","182":"chunk-web-stories-template-92","183":"chunk-colorthief","184":"chunk-ffmpeg","185":"chunk-focus-visible","186":"chunk-fonts","187":"chunk-web-stories-textset-0","188":"chunk-web-stories-textset-1","189":"chunk-web-stories-textset-2","190":"chunk-web-stories-textset-3","191":"chunk-web-stories-textset-4","192":"chunk-web-stories-textset-5","193":"chunk-web-stories-textset-6","194":"chunk-web-stories-textset-7"}[chunkId]||chunkId) + "." + {"0":"48a51d55","1":"b83655e0","2":"8fad1b4f","3":"07d18992","4":"59b0643e","5":"e1e99c11","6":"20d41856","7":"1dd26765","8":"1e5d0ed3","9":"b59f9da1","10":"c15767d5","11":"aae4ddb2","12":"1bdbbc5b","13":"18a7c7d8","14":"3d4dc056","15":"56955ff4","16":"a24de9bd","17":"3c65f5e1","18":"06314245","19":"ba136860","20":"b0f35116","21":"12f30662","22":"70796768","23":"91c05d8b","24":"88ef2afc","25":"44cda21f","26":"f5314876","27":"ebaa3c55","28":"68c90bab","29":"bdd8092e","30":"c3c4f6d2","31":"ec166979","32":"8c2d5420","33":"50103738","34":"fc7ee39f","35":"4c6d5721","36":"d96e9947","37":"f6133c67","38":"21067296","39":"ae26cc35","40":"a92506b0","41":"4bbba154","42":"5fb0b187","43":"36cbe4d7","44":"5313837f","45":"f66d4c44","46":"aa095fef","47":"c79b79c9","48":"80a773bc","49":"7713438e","50":"ac8b7fc2","51":"1c134b34","52":"c33ad4b7","53":"aa497903","54":"3954ee73","55":"6b145bfd","56":"b5a4b93d","57":"8448ef4d","58":"4ca707b5","59":"70e89f2e","60":"e5597443","61":"5af513a7","62":"330447d3","63":"627a9d4d","64":"667f47d8","65":"2436628d","66":"0f0be676","67":"75d6328a","68":"f6ac35cf","69":"1991ff62","70":"15bbc7e8","71":"d4e4df68","72":"0da18fb6","73":"160a1738","74":"91946bc1","75":"a16631c4","76":"67f94852","77":"32ba4228","78":"76b6455a","79":"33f7d45c","80":"8128c927","81":"cd8ddacf","82":"147d3733","83":"5bc87b42","84":"3188709f","85":"5a37df59","86":"fc3cd4b4","87":"4da7c42a","88":"4c43d356","89":"28ca3e1e","90":"17239ad5","91":"78341ec3","92":"c8f6f270","93":"3598dfd9","94":"55c6cf06","95":"4a0a4396","96":"101ad38d","97":"ed64badc","98":"82eed292","99":"e9d07e73","100":"43b312ac","101":"fb8c3ee4","102":"ff58bc66","103":"a1ade611","104":"afc26b4c","105":"3e952456","106":"9a72626e","107":"b1a5d014","108":"bb451c93","109":"44bce0db","110":"1843e2c8","111":"ad2cd93a","112":"966cd0a3","113":"de4e74ab","114":"9e08a000","115":"e25328bd","116":"954bf846","117":"6a6dfadd","118":"c4dce167","119":"af4b23e5","120":"3f7daba7","121":"17e99437","122":"a9e0e3ce","123":"de9bf439","124":"6f77faf7","125":"5ad15b78","126":"e0295039","127":"f44cd816","128":"ce173064","129":"121197c9","130":"26959443","131":"b9f4f881","132":"8a0d3f02","133":"fe6c3ab0","134":"8a168108","135":"49b1f7c6","136":"4c86ef64","137":"86edf4c8","138":"d8b5359c","139":"d78d831f","140":"2c41c541","141":"48a0a8e7","142":"1bd6e8f3","143":"59ca45c4","144":"4162ed51","145":"c79ab928","146":"5d82a7df","147":"4078b758","148":"3a3d3238","149":"88b2833f","150":"e2414f8c","151":"1313b681","152":"51f95828","153":"2b214a73","154":"6566d9db","155":"2e2f3be1","156":"4c58bf9f","157":"cfced601","158":"41990f73","159":"d9983495","160":"7d690ac6","161":"d14766fd","162":"a6fffda6","163":"e882f777","164":"a447be21","165":"42ffcccc","166":"6920211d","167":"73044bf6","168":"ffbe1ed0","169":"e9a85f55","170":"5f53fc5c","171":"49842d28","172":"06b1413a","173":"7a4f27ed","174":"b8cd2a0b","175":"44e78aea","176":"b92e3a0a","177":"000ad30f","178":"c6ff53e4","179":"315d0ca4","180":"07d1cb60","181":"6514e73f","182":"d603c0af","183":"3613b2a6","184":"10c30e28","185":"6df72458","186":"9397a13a","187":"8a5bbb69","188":"37ad1a16","189":"36599150","190":"a007c7fe","191":"45c8ae09","192":"9dfeb626","193":"61a070df","194":"2c6d0ce5","198":"10ce2d62","199":"e4308e6a","200":"9230fbc8","201":"662a2877","202":"767999ff","203":"1ba1a344"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpstoryteller-studio"] = this["webpackJsonpstoryteller-studio"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
